module.exports = __webpack_public_path__ + "img/bio3.3b95338b.png";